import React from 'react';
import { motion } from 'framer-motion';

// Shared viewport entrance, matching the spring/blur motion used in Watermelon UI hero-22.
export const copyVariants = {
  hidden: { opacity: 0, y: 16, filter: 'blur(6px)' },
  visible: {
    opacity: 1,
    y: 0,
    filter: 'blur(0px)',
    transition: { type: 'spring', stiffness: 200, damping: 26, mass: 1 },
  },
};

export const staggerVariants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.12, delayChildren: 0.08 } },
};

export function Stagger({ as = 'div', className, children, amount = 0.25 }) {
  const Tag = motion[as];
  return (
    <Tag
      className={className}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount }}
      variants={staggerVariants}
    >
      {children}
    </Tag>
  );
}

export function Item({ as = 'div', className, children, ...rest }) {
  const Tag = motion[as];
  return (
    <Tag className={className} variants={copyVariants} {...rest}>
      {children}
    </Tag>
  );
}
